@if(participationCount > 0){
    @if(dontWantToAnswerItem.count !== participationCount){
        <div class="result-container">
            <span class="stars-placeholder">★★★★★</span>
            <div class="stars" [ngStyle]="{'--rating': average.averageScore}"></div>
            <div class="score">{{average.averageScore}} <sub>/5</sub></div>
        </div>
        <p class="infos pb-2">
            @if(average.people === 1){
                {{'poll_results.stars_based' | translate}} {{average.people}} {{ 'poll_results.stars_answer' | translate}}
            }@else{
                {{'poll_results.stars_based' | translate}} {{average.people}} {{ 'poll_results.stars_answers' | translate}}
            }
            @if(dontWantToAnswerItem.count > 0){
                <small class="d-block">
                    {{'poll_results.stars_additionally' | translate}} "{{dontWantToAnswerItem.label}}" {{ 'poll_results.stars_dont-want-answer' | translate}} {{dontWantToAnswerItem.count}} 
                    @if(dontWantToAnswerItem.count === 1){
                        {{'poll_results.stars_time' | translate}}
                    }@else{
                        {{'poll_results.stars_times' | translate}}
                    }
                </small>
            }
        </p>
    }@else {
        <div class="alert alert-warning pb-1">
            <div class="stars" [ngStyle]="{'--rating': average.averageScore}"></div>
            <div class="text-center fs-6 fst-italic">{{'poll_results.stars_no-answer' | translate}}</div>
        </div>
        <small class="d-block text-center fs-6 fst-italic">
            {{ 'poll_results.stars_option' | translate }} "{{dontWantToAnswerItem.label}}" {{ 'poll_results.stars_dont-want-answer' | translate}} {{dontWantToAnswerItem.count}} 
            @if(dontWantToAnswerItem.count === 1){
                {{'poll_results.stars_time' | translate}}
            }@else{
                {{'poll_results.stars_times' | translate}}
            }
        </small>
    }
}@else{
    <div class="alert alert-warning mt-2 mb-0 fs-6 fst-italic">
        {{'poll_results.no_data'| translate}}
    </div>
}